<template>
    <b-navbar toggleable="xl" type="dark" variant="info">
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
      <b-navbar-brand :to="{ name: 'dashboard' }">
        <img alt="Vue logo" src="../../../assets/dentalia.png" class="dentaliaLogo"/>
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav style="flex-wrap: wrap">

        <template v-for="menu in menuArray">
          <Menu :key="menu.idMenu" :menu="menu"></Menu>
        </template>

        <b-nav-item class="custom-menu-nav-link" @click="abrirMembresias()">
          Portal Ventas Membresías
        </b-nav-item>

      </b-collapse>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right id="menu-usuario" class="custom-menu-nav-link custom-menu-dropdown-menu w-100" >
          <!-- Using 'button-content' slot -->

          <template #button-content>
            <table>
              <td>
                <em>{{usrName}}</em>
                <br/>
                <template v-if="clinicas !== undefined && clinicas !== null && clinicas.length > 1">
                  <v-select :clearable="false" :options="clinicas"
                            v-model="clinicaActual" :reduce="(variable) => variable.idClinica" label="nombreClinica"
                            @click.native.stop.prevent class="opcion-menu" @input="refrescar()">
                    <span slot="no-options">No hay valores disponibles</span>
                  </v-select>
                </template>
                <em v-else>== {{nombreClinica}} ==</em>
              </td>
              <td class="item-menu-usuario">
                <font-awesome-icon icon="user" />
              </td>

            </table>
          </template>
          <b-dropdown-item v-on:click="exit()">
            <font-awesome-icon icon="sign-out-alt"/>
            Cerrar sesión
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>

    </b-navbar>
</template>

<script>
import Menu from "@/components/menu";

export default {
  name: "nav1",
  components: {
    Menu,
  },
  props: {
    msg: String,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    menuSeleccionado: {
      subMenus: []
    },
    usrName: null,
    nombreClinica: null,
    menuArray: [],
    activeRoutes: [],
    clinicas: [],
    clinicaActual: null,
  }),
  beforeCreate: function () {
    if (!this.$session.exists()) {
      this.$router.push("/");
    }
  },
  beforeMount() {
    this.getMenu();
    this.usrName = this.$localStorageService.getNombreCompletoUsuario();
    this.nombreClinica = this.$localStorageService.getNombreClinica();
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.clinicaActual = this.$localStorageService.getIdClinica();
    this.getClinicasHeaders()

  },
  watch: {
    clinicaActual() {
      this.$localStorageService.setClinicaActual(this.clinicaActual);
    }
  },
  methods: {
    inicio() {
      this.$router.push({name: 'dashboard'});

    },
    getClinicasHeaders() {
      const parametros = {idUsuario: this.$localStorageService.getIdUsuario()}
      this.$http
          .post(
              this.$api +
              "catalogos/listaClinicasHeaders", parametros
          )
          .then(response => {
            if (Array.isArray(response.data.data) == true) {
              this.clinicas = response.data.data;
              this.clinicas.sort(function (a, b) {
                if (a.nombreClinica > b.nombreClinica) {
                  return 1;
                }
                if (a.nombreClinica < b.nombreClinica) {
                  return -1;
                }
                // a must be equal to b
                return 0;
              });
              let verificarExiteClicnica = this.$localStorageService.getIdClinica();
              let existeClinica = null;
              existeClinica = this.clinicas.find(cli => cli.idClinica === verificarExiteClicnica)
              if (existeClinica != null) {
                this.clinicaActual = this.$localStorageService.getIdClinica();
              } else {
                this.clinicaActual = this.clinicas[0].idClinica;
                this.$localStorageService.setClinicaActual(this.clinicaActual);
              }


            }
          })
          .catch((error) => {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: "Error al obtener el clinicas",
            });
            console.error(error);
          });

    },
    exit() {
      this.loading = true;
      this.$session.destroy();
      this.$router.push({
        name: "login"
      });
      this.$localStorageService.removeMenus();
      this.$localStorageService.removePostales();
      sessionStorage.removeItem("sso_cred");
    },
    abrirMembresias() {
      const base = process.env.VUE_APP_PORTAL_VENTAS_MEMBRESIAS;
      if (!base) {
        this.$swal.fire({
          icon: "error",
          title: "Error",
          text: "El portal de Ventas Membresías no está configurado.",
        });
        return;
      }
      // SSO: se envían las credenciales cifradas (usuario+contraseña) en el
      // fragment (#) para que Membresías inicie sesión sin re-login.
      const cred = sessionStorage.getItem("sso_cred");
      if (!cred) {
        this.$swal.fire({
          icon: "error",
          title: "Error",
          text: "No hay una sesión activa para continuar.",
        });
        return;
      }
      const url = `${base.replace(/\/$/, '')}/sso#data=${encodeURIComponent(cred)}`;
      window.open(url, '_blank', 'noopener');
    },
    myFunction(number) {
      document.getElementById(number).classList.toggle("show");
      this.menuArray.forEach(function (value) {
        if (value.idMenu == number) {
          value.active = value.active == false ? true : false;
        }
      });
    },
    ShowMenu(subMenus, id) {
      this.activeRoutes = subMenus;
      this.menuArray.forEach(function (value) {
        value.active = false;
        if (value.idMenu == id) {
          value.active = value.active == false ? true : false;
        }
      });
    },
    getMenu() {
      if (this.$localStorageService.existMenus()) {
        this.menuArray = this.$localStorageService.getMenus();

      } else {
        const parametros = {idUsuario: this.$localStorageService.getIdUsuario()}
        this.$http
            .post(
                this.$api +
                "menu/obtenerMenuUsuario", parametros
            )
            .then(response => {
              if (Array.isArray(response.data.data) == true) {
                response.data.data.forEach(element => {
                  if (element.subMenus.length != 0) {
                    element.active = false;
                    element.subMenus.forEach((elementSub) => {
                      elementSub.active = false;
                    });
                  }
                });

                this.menuArray = response.data.data; // !HARDCODEO menuArray
                this.$localStorageService.setMenus(this.menuArray);
              }
            })
            .catch((error) => {
              this.$swal.fire({
                icon: "error",
                title: "Error",
                text: "Error al obtener el menu",
              });
              console.error(error);
            });
      }
    },
    getSvg(url) {
      try {
        return require('../../../assets/menu/' + url + '.svg')
      } catch (error) {
        return require('../../../assets/menu/0.svg')
      }
    },
    refrescar() {
      this.$router.go();
    },
    activo(item) {
      if (parseInt(this.localMenu) === parseInt(item.idMenu)) {
        return true;
      }
      return false
    },
  },
}
</script>

<style scoped>
.single-line {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: inherit;
}
</style>